/**
 * Verified US Customer & Doctor Reviews
 */

export const reviews = [
  // 1. Clinical Practitioner & Herniated Disc (Doctor)
  {
    id: 1,
    author: 'Dr. Marcus Vance, DPT, OCS',
    role: 'Doctor of Physical Therapy',
    location: 'Austin, TX',
    badge: 'Clinical Practitioner',
    rating: 5,
    date: 'August 28, 2026',
    title: 'Infinitely safer than Teeter inversion tables for 90% of my spine patients',
    content: 'In our physical therapy clinic, we have banned traditional 90-degree inversion tables due to eye pressure and cervical shear risks. The Evminov board offers what clinical motorized traction tables offer at a fraction of the cost: calibrated, gentle angles on a compliant pine surface. I now recommend it to all my patients with L5-S1 disc protrusions.',
    verified: true,
    conditionTag: 'Herniated Disc (L5-S1)',
    category: 'Herniated Disc Clinical Practitioner',
  },

  // 2. Herniated Disc - Patient
  {
    id: 2,
    author: 'David M.',
    role: 'Structural Engineer',
    location: 'Seattle, WA',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'August 19, 2026',
    title: 'Avoided L4-L5 microdiscectomy surgery after 8 weeks on the board',
    content: 'My neurosurgeon had scheduled an L4-L5 microdiscectomy in November after an MRI showed a 7mm extrusion causing severe foot drop and agony. A colleague recommended the Evminov method. I started at 10 degrees twice daily with the micro-kinetic pelvic tilts. By week 4, numbness receded. By week 8, follow-up MRI showed significant disc volume retraction. Canceled surgery. Truly miraculous biomechanical engineering.',
    verified: true,
    conditionTag: 'Herniated Disc (L4-L5)',
    category: 'Herniated Disc',
  },

  // 3. Herniated Disc - Patient
  {
    id: 3,
    author: 'Claire S.',
    role: 'High School Principal',
    location: 'Columbus, OH',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'July 24, 2026',
    title: 'Gentle 12-degree traction rehydrated my degenerated lumbar discs',
    content: 'Years of standing on concrete school floors left me with severe multi-level degenerative disc disease and L5-S1 bulging. Other traction devices pulled too violently, triggering protective muscle spasms. The Carpathian pine board flexes just enough to cushion the sacrum. I do 10 minutes every morning before school and my lumbar stiffness has vanished.',
    verified: true,
    conditionTag: 'Herniated Disc & Degeneration',
    category: 'Herniated Disc',
  },

  // 4. Herniated Disc - Patient
  {
    id: 4,
    author: 'Robert H.',
    role: 'Retired Fire Captain',
    location: 'Phoenix, AZ',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'June 15, 2026',
    title: 'Restored intervertebral disc space and ceased prescription pain meds',
    content: 'Thirty years in the fire service destroyed my lower lumbar spine. Cortisone injections stopped working after 6 months. My physical therapist suggested an in-home traction board. Within 3 weeks of gentle 18-degree decompression, the sharp stabbing nerve pain ceased. Now doing the maintenance exercise protocol 5 days a week. Worth ten times the price.',
    verified: true,
    conditionTag: 'Herniated Disc (L4-S1)',
    category: 'Herniated Disc',
  },

  // 5. Athletes & Lifters
  {
    id: 5,
    author: 'Tyler R.',
    role: 'Competitive Powerlifter (USAPL 83kg)',
    location: 'Denver, CO',
    badge: 'Verified Athlete Buyer',
    rating: 5,
    date: 'September 2, 2026',
    title: 'Saved my lifting career after a 495 lb deadlift tweak',
    content: 'After pulling heavy singles, my lower back felt completely jammed and compressed for 3 days. Standard hanging from a pullup bar doesn\'t work because you can\'t relax your back muscles. Lying relaxed on this board at a 25-degree incline unloads the spinal discs while your spinal erectors fully relax. 15 minutes post-deadlifts is now mandatory for me. Board is rock solid.',
    verified: true,
    conditionTag: 'Athletic Recovery',
    category: 'Athletic Recovery',
  },

  // 6. Athletes & Lifters
  {
    id: 6,
    author: 'Marcus "Axe" Sterling',
    role: 'CrossFit Level 3 Coach & Gym Owner',
    location: 'Miami, FL',
    badge: 'Verified Coach',
    rating: 5,
    date: 'August 11, 2026',
    title: 'Essential post-WOD lumbar decompression for heavy squats and cleans',
    content: 'We installed two Evminov boards in our athletes\' mobility corner. Heavy barbell volume compresses lumbar discs significantly across an intensive session. Having athletes decompress at 25-30 degrees with relaxed spinal erectors immediately relieves axial fatigue and cuts recovery time in half. It is now standard protocol for our regional competitors.',
    verified: true,
    conditionTag: 'Athletic Recovery',
    category: 'Athletic Recovery',
  },

  // 7. Athletes & Lifters
  {
    id: 7,
    author: 'Jessica Lin',
    role: 'Ultra-Marathoner & Triathlete',
    location: 'Boulder, CO',
    badge: 'Verified Athlete Buyer',
    rating: 5,
    date: 'July 30, 2026',
    title: 'Eliminated chronic sacral jamming from 60-mile weekly road pounding',
    content: 'High-mileage road running causes relentless repetitive impact on the L5-S1 junction. I used to battle SI joint inflammation every peak marathon block. 12 minutes on the Evminov board with gentle rhythmic leg extensions immediately decompresses my lower lumbar vertebrae. Waking up the next day with zero lower back tightness has been game-changing.',
    verified: true,
    conditionTag: 'Athletic Recovery',
    category: 'Athletic Recovery',
  },

  // 8. Athletes & Lifters
  {
    id: 8,
    author: 'Dmitriy K.',
    role: 'Olympic Weightlifting Coach (Master of Sport)',
    location: 'Philadelphia, PA',
    badge: 'Elite Coach',
    rating: 5,
    date: 'June 22, 2026',
    title: 'Standard equipment in European training halls — thrilled it is in the US',
    content: 'Back in Ukraine, every gymnastics and weightlifting hall had an Evminov board mounted to the Swedish wall. In the US, athletes waste thousands on vibrating massage guns that only treat surface fascia. This board mechanically decompresses deep vertebral joints while keeping paraspinal stabilizers active. It is the gold standard for heavy lifters.',
    verified: true,
    conditionTag: 'Athletic Recovery',
    category: 'Athletic Recovery',
  },

  // 9. Sciatica Relief
  {
    id: 9,
    author: 'Elena Rostova',
    role: 'Software Architect',
    location: 'Burbank, CA',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'August 14, 2026',
    title: 'Got fast delivery from their Sun Valley warehouse — Sciatica gone in 3 weeks',
    content: 'I had shooting sciatic nerve pain down my right leg from sitting 10 hours a day coding. MRI showed a 4mm bulge at L4-L5. I grew up hearing about Evminov in Europe, and finding it locally stocked in California was amazing. Fast UPS delivery, easy to mount to wall studs. The included Glisson loop also cured my chronic desk headaches.',
    verified: true,
    conditionTag: 'Sciatica Relief',
    category: 'Sciatica Relief',
  },

  // 10. Sciatica Relief
  {
    id: 10,
    author: 'Arthur Pendelton',
    role: 'Long-Haul Commercial Driver',
    location: 'Dallas, TX',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'August 03, 2026',
    title: 'Crucial relief for 14-hour seated sciatica and piriformis flare-ups',
    content: 'Road vibration and sitting 14 hours a day gave me excruciating sciatica shooting from my left glute all the way down to my heel. I couldn\'t sleep more than 2 hours without waking in pain. Mounted this board in my garage. Doing 15-degree lumbar decompression relieved the nerve root compression in under two weeks. I can drive pain-free again.',
    verified: true,
    conditionTag: 'Sciatica Relief',
    category: 'Sciatica Relief',
  },

  // 11. Sciatica Relief
  {
    id: 11,
    author: 'Dr. Svetlana M., DDS',
    role: 'Dental Surgeon',
    location: 'Charlotte, NC',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'July 18, 2026',
    title: 'Fixed unilateral asymmetric sciatica from clinical surgical posture',
    content: 'As a dental surgeon, I lean over patients to the right for 8 hours daily. This caused asymmetric lumbar curvature and pinched my sciatic nerve root. Physical therapy helped temporarily, but daily home decompression on the Evminov board created the permanent decompression I needed. The clinical protocol guide is exceptionally thorough.',
    verified: true,
    conditionTag: 'Sciatica Relief',
    category: 'Sciatica Relief',
  },

  // 12. Sciatica Relief
  {
    id: 12,
    author: 'Gregory T.',
    role: 'Corporate Executive',
    location: 'Atlanta, GA',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'June 09, 2026',
    title: 'Instant relief when acute sciatica spasms strike',
    content: 'When acute sciatica hits, you cannot even walk to the car to visit a clinic. Having this hospital-grade board right in my home office is priceless. A gentle 12-degree incline with deep diaphragmatic breathing unloads the compressed nerve exit within 10 minutes. The craftsmanship of the natural wood is heirloom quality.',
    verified: true,
    conditionTag: 'Sciatica Relief',
    category: 'Sciatica Relief',
  },

  // 13. Doctors & PTs
  {
    id: 13,
    author: 'Dr. Sarah Jenkins, DC',
    role: 'Chiropractic Physician',
    location: 'San Jose, CA',
    badge: 'Chiropractic Endorsement',
    rating: 5,
    date: 'June 30, 2026',
    title: 'The natural wood flex makes a world of difference',
    content: 'Unlike hard plastic foam rollers or stiff steel benches, natural pine has a mechanical resonance and gentle compliance that molds to human spinal curves. When patients engage in micro-movements under mild traction, disc nutrition (imbibition) improves dramatically. A true masterpiece of Ukrainian sports medicine.',
    verified: true,
    conditionTag: 'Clinical Practitioner',
    category: 'Clinical Practitioner',
  },

  // 14. Doctors & PTs
  {
    id: 14,
    author: 'Dr. Igor Vasylenko, MD, PhD',
    role: 'Neuro-Orthopedic Specialist',
    location: 'Chicago, IL',
    badge: 'Spine Specialist',
    rating: 5,
    date: 'May 28, 2026',
    title: 'Trained at the Kyiv Institute in 2004 — clinically superior to motorized traction',
    content: 'In motorized traction machines like DRX9000, patient muscle resistance often fights the computerized motor, creating dangerous micro-tears in paraspinal rotatores. The Evminov method uses patient-controlled fractional bodyweight on a resonant pine incline, ensuring protective spasm reflexes are never triggered. I prescribe it as standard home therapy.',
    verified: true,
    conditionTag: 'Clinical Practitioner',
    category: 'Clinical Practitioner',
  },

  // 15. Doctors & PTs
  {
    id: 15,
    author: 'Dr. Hannah Weiss, PT, DPT',
    role: 'Board-Certified Physical Therapist',
    location: 'Boston, MA',
    badge: 'McKenzie Certified MDT',
    rating: 5,
    date: 'May 04, 2026',
    title: 'Perfect synergy with directional preference and McKenzie spinal protocols',
    content: 'For patients with lumbar radiculopathy, centralizing their symptoms is our primary goal. The adjustable carriage of the Evminov board allows precise patient positioning into mild extension or flexion depending on their directional preference. It bridges the gap between in-clinic therapy and daily home adherence seamlessly.',
    verified: true,
    conditionTag: 'Clinical Practitioner',
    category: 'Clinical Practitioner',
  },

  // 16. Doctors & PTs
  {
    id: 16,
    author: 'Dr. Christopher Meyer, DC, CCSP',
    role: 'Sports Chiropractic Physician',
    location: 'San Diego, CA',
    badge: 'Clinical Practitioner',
    rating: 5,
    date: 'April 19, 2026',
    title: 'Fills the HSA/FSA medical necessity requirement with legitimate clinical codes',
    content: 'My patients easily obtain Letters of Medical Necessity for their HSA/FSA under HCPCS E0941. Having clinical trials with 30 years of documentation from leading medical institutes makes writing the prescription effortless. The durability of the Carpathian pine construction easily withstands heavy daily patient use.',
    verified: true,
    conditionTag: 'Clinical Practitioner',
    category: 'Clinical Practitioner',
  },

  // 17. Inversion Alternative (All Reviews)
  {
    id: 17,
    author: 'Brian K.',
    role: 'Commercial Airline Pilot',
    location: 'Chicago, IL',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'July 19, 2026',
    title: 'High blood pressure prevented me from using Teeter — this is the solution',
    content: 'My flight physician warned me against hanging upside down because my systolic blood pressure spikes. The Evminov board allows me to decompress at an easy 15-degree angle. I lie down, do the gentle sway exercises, and my lumbar tightness dissolves without any blood rushing to my head. Folds right against the wall in my spare room.',
    verified: true,
    conditionTag: 'Inversion Alternative',
    category: 'Inversion Alternative',
  },

  // 18. Renters Stand (All Reviews)
  {
    id: 18,
    author: 'Michael G.',
    role: 'Apartment Renter / Accountant',
    location: 'New York, NY',
    badge: 'Verified Buyer',
    rating: 5,
    date: 'May 11, 2026',
    title: 'Bought with the Free-Standing Stand — zero wall holes in my rental',
    content: 'I was worried about my apartment deposit in Manhattan because our landlord prohibits heavy wall mounts. I bought the Evminov board with the demountable ladder stand. It takes barely 3 square feet, super stable even at 30 degrees, and I paid in 4 installments with Klarna. Best health purchase of my life.',
    verified: true,
    conditionTag: 'Renters Stand',
    category: 'Renters Stand',
  },
];
